import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { formatNumber } from "@utils/data-display";

/** Convert Stripe product data to card item details for display */
export function convertStripeProductToPackageCardItem(products) {
  if (products.length === 0) {
    return [];
  }

  /** Sort products by price ascending */
  const sortedProducts = products.sort((a, b) => parseFloat(a.price.price) - parseFloat(b.price.price));

  /**
   * Index for the 'most popular' badge
   * Middle index is chosen if the list is odd,
   * or the first of the two middle items if even.
   */
  const middleIndex = Math.ceil(sortedProducts.length / 2) - 1;

  // TODO: Restore the per-package savings badge once the 50% beta discount ends.
  // https://faro01.atlassian.net/browse/ST-3530
  // const basePackage = sortedProducts[0];
  // const basePricePerToken =
  //   parseFloat(basePackage.price.price) / basePackage.tokenAmount;

  return sortedProducts.map((product, index) => {
    // TODO: Restore the per-package savings badge once the 50% beta discount ends.
    // https://faro01.atlassian.net/browse/ST-3530
    // let titleDescription: string | undefined;
    // if (index > 0) {
    //   const equivalentPrice = product.tokenAmount * basePricePerToken;
    //   const savings = equivalentPrice - parseFloat(product.price.price);
    //   const savingsPercentage = (savings / equivalentPrice) * 100;
    //   if (savingsPercentage > 0) {
    //     titleDescription = `Save ${savingsPercentage.toFixed(0)}%`;
    //   }
    // }

    // 50% off will be applied during beta release
    const titleDescription = "Save 50% during beta";
    const discountedPrice = parseFloat(product.price.price) / 2;
    return {
      // Using french number format to have the space separated number format according to design
      title: `${formatNumber(product.tokenAmount)} ${CREDITS_DISPLAY_NAME}`,
      subtitle: formatStripeDisplayPrice(product.price.price),
      correctedSubtitle: formatStripeDisplayPrice(discountedPrice.toString()),
      badgeText: product.badge,
      value: product.id,
      additionalBadgeText: index === middleIndex ? "most popular" : undefined,
      titleDescription
    };
  });
}

/**
 * Format Stripe price for display in full currency units.
 *
 * @param {string} priceInCents - The price comes from stripe in cents as a string.
 * @return {string} The formatted price in full currency unit(USD/EUR).
 */
export function formatStripeDisplayPrice(priceInCents) {
  const priceInCurrencyUnit = parseFloat(priceInCents) / 100;
  return `$${priceInCurrencyUnit.toLocaleString("en-US")}`;
}